import {Injectable} from "@angular/core";
import {HttpClient} from "@angular/common/http";
import {environment} from "../../../environments/environment";
import {map, Observable} from "rxjs";

@Injectable({
  providedIn: 'root'
})

export class StagingService {
  api = environment.apiUrl;

  constructor(private http: HttpClient) {
  }

  getBuildingRoomTypes(): Observable<IBuildingRoomType[]> {
    return this.http.get<IBuildingRoomType[]>(`${this.api}/Info/GetBuildingRoomTypes`)
  }

  getBuildingRoomTypeItems(roomTypeID: number): Observable<IBuildingRoomTypeItem[]> {
    return this.http.get<IBuildingRoomTypeItem[]>(`${this.api}/Info/GetBuildingRoomTypeItems`)
      .pipe(
        map(items =>
          items.filter(item => item.roomTypeID === roomTypeID))
      )
  }

  getBuildingRooms(buildingID: number, roomTypeID: number): Observable<IGetBuildingRoom[]> {
    return this.http.get<IGetBuildingRoom[]>(`${this.api}/Buildings/GetBuildingRooms?buildingID=${buildingID}&roomTypeID=${roomTypeID}`);
  }

  delBuildingRooms(buildingRoomID: number) {
    return this.http.delete(`${this.api}/Buildings/DelBuildingRooms?buildingRoomID=${buildingRoomID}`);
  }

  setBuildingRoomsFloorValues(obj: ISetBuildingRoomsFloorValues) {
    return this.http.post(`${this.api}/Buildings/SetBuildingRoomsFloorValues`, obj);
  }

  setBuildingRoomValues(obj: ISetBuildingRoomValues) {
    return this.http.post(`${this.api}/Buildings/SetBuildingRoomValues`, obj);
  }

  getBuildingRoomSales(buildingID: number): Observable<IBuildingRoomSale[]> {
    return this.http.get<IBuildingRoomSale[]>(`${this.api}/Buildings/GetBuildingRoomSales?id=${buildingID}`);
  }

  insBuildingRoomFiles(buildingRoomID: number, fileTypeID: number, attachment: File) {
    const formData = new FormData();
    formData.append('buildingRoomID', buildingRoomID.toString());
    formData.append('fileTypeID', fileTypeID.toString());
    formData.append('attachment', attachment);
    return this.http.post(`${this.api}/Buildings/InsBuildingRoomFiles`, formData, {observe: 'response'});
  }

  removePlan(fileID) {
    return this.http.delete(`${this.api}/Buildings/DelBuildingRoomFiles?fileId=${fileID}`, {});
  }


}

export interface IGetBuildingRoom {
  id: number;
  buildingID: number;
  floorID: number; // номер этажа
  placeNumber: number; // номер помещения
  roomTypeItemID: number;
  roomTypeItemTitle: string;
  entrance: string;
  area: number;
}

export interface IBuildingRoomType {
  id: number;
  title: string;
}

export interface IBuildingRoomTypeItem extends IBuildingRoomType {
  roomTypeID: number;
}

export interface ISetBuildingRoomsFloorValues {
  buildingID: number;
  roomTypeItemID: number;
  floorID: number;
  placeCount: number;
  roomTypeID: number;
}

export interface ISetBuildingRoomValues {
  buildingID: number;
  buildingRoomID?: number;
  roomTypeItemID?: number;
  entrance?: string;
  floorID?: number;
  placeNumber?: number;
  area?: number;
  roomTypeItemTitle?: string;

  saleDate?: string;
  saleAmount?: number;
  priceAmount?: number;
}

export interface IBuildingRoomSale extends IGetBuildingRoom {
  dbFileID?: number | null;
  fileName?: string | null;
  saleDate?: string | null;
  saleAmount?: number | null;
  priceAmount?: number | null;
  extension?: string | null;
}